export class AntDFileHelper {
  static getExtension (file) {
    return file.name.split('.').pop();
  }

  static getBytes (file) {
    return file.size / 1024 / 1024;
  }
}
